import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { routingProfileServiceEnvironment } from '../routing-profile-service-environment';
import { routingProfileSchema } from '../schemas/routing-profile.schema';

/**
 * Duplicate an existing Routing Profile with a new name
 * @param routingProfileId ID of the Routing Profile to duplicate
 * @param newName The new name for the duplicated routing profile
 * @returns A Data object containing the newly created Routing Profile details
 */
export function postRoutingProfilesIdDuplicate(
  this: unknown,
  routingProfileId: number,
  newName: string
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          routingProfileServiceEnvironment.resolve(this).routingProfilesUrl
        }/${encodeURIComponent(routingProfileId)}/duplicate`,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify(newName),
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
        data: routingProfileSchema,
      })
    )
  );
}
